(function($){
    $(document).ready(function(){

        function addAddress2(){
//             console.log("addAddress2");
            let label = document.querySelector('.address_line_2.ginput_address_line_2 .gform-field-label');
            if(label){
                label.innerHTML = 'Add Address Line 2';
                label.addEventListener('click',function(){
                    label.innerHTML = 'Address Line 2';
                    label.parentElement.classList.add('show-input');
                });
            }
        }
        addAddress2();

        jQuery(document).on('gform_post_render', function(event, form_id, current_page){
            setTimeout(function(){
                addAddress2();
            }, 300);
        });

        let spreader = document.querySelector('span.spreader');
        let spreaderText = document.querySelector('div.spreader-text');
        let spreaderClose = document.querySelector('span.spreader-close');

        if(spreader && spreaderText){
            spreader.addEventListener('click',function(){
                spreader.classList.add('spreader-hide');
                spreaderText.classList.add('spreader-text-show');
            });
        }
        if(spreaderClose){
            spreaderClose.addEventListener('click',function(){
                if(spreader.classList.contains('spreader-hide')){
                    spreader.classList.remove('spreader-hide')
                }
                if(spreaderText.classList.contains('spreader-text-show')){
                    spreaderText.classList.remove('spreader-text-show');
                }
            });
        }

//         if($(".wc_gc_giftcard_product .JonathanGreen-product-information .single_add_to_cart_button").length){
//             var $button = $(this);
//             $( document ).on( "ajaxComplete", function() {
//                 if(!$button.hasClass('disabled')){
//                     console.log("button.hasClass.disabled");
//                     $('.JG-sticky-add-to-cart_form .single_add_to_cart_button').removeClass('disabled wc-variation-selection-needed');
//                     $('.JG-sticky-add-to-cart_form .woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-disabled');
//                 }
// //                 console.log('sss')
//             } );
//         }

        // $(".wc_gc_giftcard_product .JonathanGreen-product-information .single_add_to_cart_button").on("event", function(){
        //     $(this).addClass("rectangle");
        // });

        // let repeaterField = document.querySelector('.gfield_repeater_buttons button.add_repeater_item');
        // let repform = document.querySelector('form#gform_22');
        // let formSubmit = document.querySelector('form#gform_22 button[type="submit"]');
        // let errors = true;
        // if(repform){
        //     repform.addEventListener('click', revalidate);
        // }
        // function revalidate(e){
        //     console.log("repeaterfield", e.target);
        //     if(e.target && e.target.classList.contains('add_repeater_item')){
        //         formSubmit.setAttribute('disabled', 'disabled');
        //         setTimeout(function(){
        //             startValidation();
        //         }, 300);
        //     }
        //     if(e.target && e.target.classList.contains('remove_repeater_item')){
        //         formSubmit.setAttribute('disabled', 'disabled');
        //         setTimeout(function(){
        //             startValidation();
        //         }, 300);
        //         document.querySelector('form .gfield--type-text input[type="text"]').click();
        //     }
        // }
        // if(repeaterField && formSubmit){
        //     formSubmit.setAttribute('disabled', 'disabled');
        //     startValidation();
        // }
        // function startValidation(e){
        //     let inputs = repform.querySelectorAll('input[aria-required="true"], select[aria-required="true"]');
        //     inputs.forEach(function(item){
        //         item.addEventListener('click', validateInput);
        //         item.addEventListener('change', validateInput);
        //         item.addEventListener('keyup', validateInput);
        //     });
        //     console.log("allinputs", inputs);
        // }
        // function validateInput(e){
        //     let hasErr = [];
        //     let allinputs = repform.querySelectorAll('input[aria-required="true"], select[aria-required="true"]');
        //     allinputs.forEach(function(item){
        //         if(item.tagName == 'INPUT'){
        //             if(item.parentElement.classList.contains('ginput_container_email')){
        //                 if(item.value == '' || !item.value || validateEmail(item.value) == null){
        //                     hasErr.push(item);
        //                 }
        //             }else if(item.parentElement.classList.contains('ginput_container_phone') ){
        //                 if(item.value == '' || !item.value || validatePhone(item.value) == null){
        //                     hasErr.push(item);
        //                 }
        //             }else{
        //                 if(item.value == '' || !item.value){
        //                     hasErr.push(item);
        //                 }
        //             }
        //         }
        //         if(item.tagName == 'SELECT'){
        //             // console.log("select", item.value);
        //             if(item.value == 'selected' || item.value == 'select' || item.value == '' || !item.value){
        //                 hasErr.push(item);
        //             }
        //         }
        //         // console.log("itemval", item.value);
        //     });
        //     if(hasErr.length == 0){
        //         formSubmit.removeAttribute('disabled');
        //     }else{
        //         formSubmit.setAttribute('disabled', 'disabled');
        //     }
        // }
        // function validateEmail(email){
        //     return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        // }
        // function validatePhone(phone){
        //     return phone.match(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/);
        // }

        var giftProd = document.querySelector('.wc_gc_giftcard_product');
        var prodTitle = document.querySelector('.wc_gc_giftcard_product h1.product_title.entry-title');
        var stickyCart = document.querySelector('.JG-sticky-add-to-cart button.single_add_to_cart_button');
        if((giftProd && prodTitle) && prodTitle.innerHTML){
            prodTitle = prodTitle.innerHTML.toLowerCase();
            giftProd.classList.add("disabled-gift");
            if(prodTitle.includes('gift')){
                var ginputs = document.querySelectorAll('select[name="attribute_choose-an-amount"], select[name="attribute_choose-an-occasion"], input[name="wc_gc_giftcard_to_multiple"], input[name="wc_gc_giftcard_from"]');

                ginputs.forEach(function(elem){
                    elem.addEventListener("change", validateGift);
                    elem.addEventListener("keyup", validateGift);
                });

                var validateEmail = (email) => {
                    return email.match(
                        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
                };

                function validateGift(){
                    var errors = 0;
                    var ginputs = document.querySelectorAll('select[name="attribute_choose-an-amount"], select[name="attribute_choose-an-occasion"], input[name="wc_gc_giftcard_to_multiple"], input[name="wc_gc_giftcard_from"]');

                    ginputs.forEach(function(elem){


                        if(elem.id == 'choose-an-amount') {
                            let stickySpan = document.querySelector('.JG-sticky-add-to-cart_title .sticky_att');
                            jQuery('.JG-sticky-add-to-cart_title h5 span').text(elem.value);
                        }
                        if(elem.type == 'select-one'){
                            if(!elem.value){
                                errors++;
                            }
                        }
                        if(elem.name == 'wc_gc_giftcard_to_multiple'){
                            if(!elem.value){
                                errors++;
                            }
                            if(!validateEmail(elem.value)){
                                errors++;
                            }
                        }
                        if(elem.name == 'wc_gc_giftcard_from'){
                            if(!elem.value){
                                errors++;
                            }
                        }
                        // console.log("errors", errors);
                    });

                    if(!errors){
                        giftProd.classList.remove('disabled-gift');
                        giftProd.classList.add('enabled-gift');



                    }else{
                        giftProd.classList.add('disabled-gift');
                        giftProd.classList.remove('enabled-gift');
                    }

                    stickyCart.classList.remove('disabled');
                    stickyCart.classList.remove('wc-variation-selection-needed');
                    stickyCart.classList.remove('woocommerce-variation-add-to-cart-disabled');
                }

                stickyCart.addEventListener('click', function(){
                    var giftAddCart = document.querySelector('.woocommerce-variation-add-to-cart button.single_add_to_cart_button');
                    if(giftAddCart){
                        giftAddCart.click();
                    }
                })

            }
        }

    });
})(jQuery);
